
import React, { useEffect, useState, } from "react";

// reactstrap components
import {
  Button,
  Modal,

  ModalBody,
  Card,
  Table

} from "reactstrap";

import { URL, INPUT } from "Auth/config";
import { buscarDB, start } from 'service'

import { ComponenteInputBuscar_ } from "components/input/elementos";
import Links from "./links";
import axios from "axios";
import ReactPlayer from 'react-player';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faPlayCircle } from "@fortawesome/free-solid-svg-icons";


function Videos() {
  const [video, setVideo] = useState(null);

  const [lista, setLista] = useState([])
  const [inputBuscar, setInputBuscar] = useState({ campo: null, valido: null });
  const [open, setOpen] = useState(false);


  useEffect(() => {
    document.title = "VIDEOS-IEC";
    start(URL + '/public/listar-videos').then(json => {
      setLista(json)
    })
  }, []); //fin useEffect

  useEffect(() => {

    return () => { }
  }, [])

  const opts = {
    height: window.innerWidth <= 768 ? '200' : '250',
    width: '100%',
    playerVars: {
      autoplay: 1,
    },
  };

  const buscar = async () => {
    if (inputBuscar.valido === 'true') {
      const data = await buscarDB(URL + '/public/buscar-videos', { dato: inputBuscar.campo })
      setLista(data)
    }
  }


  return (
    <div className="contentSimple"  >
      <div className="main-container">
        <header>
          <h1>IECC <br /> <span>[ contenido de sensibilizacion en VIDEO]</span></h1>

        </header>
        <Card>
          <div className="mt-2 mb-2">
            <ComponenteInputBuscar_
              estado={inputBuscar}
              cambiarEstado={setInputBuscar}
              name="inputBuscar"
              ExpresionRegular={INPUT.INPUT_BUSCAR} //expresion regular
              placeholder="Escriba para filtrar ..."
              eventoBoton={buscar}
              etiqueta={"Buscar"}
            />
          </div>


          <Table className="tablesorter" responsive>
            <thead className="text-primary">
              <tr>
                <th ></th>
                <th >TITULO</th>
                <th>DESCRIPCION</th>
                <th >AUTOR</th>
                <th >VISTAS</th>
                <th className="text-center">FECHA PUBLICACION</th>
              </tr>
            </thead>
            <tbody>
              {lista.map(e => (
                <tr key={e.id}

                  onClick={() => {
                    setVideo({
                      id: e.id,
                      url: e.direccion,
                      titulo: e.titulo,
                      descripcion: e.descripcion,
                      view: e.views,
                      autor: e.autor
                    });
                    setOpen(true)
                    axios.post(URL + '/public/contar-visita', { id: e.id })
                    // for (let item of lista) {
                    //   if (item.id === e.id) {
                    //     item.views = item.views+1
                    //   }
                    // }
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  <td>
                    <FontAwesomeIcon icon={faPlayCircle}
                      style={{
                        color: 'blue',
                        height: '20px',
                        width: '20px',
                        cursor: 'pointer'
                      }}
                    />
                  </td>
                  <td>
                    <div className="tbl-name tbl-bold">{e.titulo}</div>
                  </td>
                  <td>
                    <div className="tbl-des ">{e.descripcion}</div>
                  </td>
                  <td>
                    <div className="tbl-name tbl-bold">{e.autor}</div>
                  </td>

                  <td>
                    <div className="tbl-des">{e.views}</div>
                  </td>
                  <td>
                    <div className="tbl-des tbl-bold">{e.fecha}</div>
                  </td>
                </tr>
              ))}

            </tbody>
            {lista.length < 1 && 'lista vacia'}
          </Table>

        </Card>
        <Modal isOpen={open} toggle={() => setOpen(!open)} className="modal-lg">
          <style>
            {`
              .modal-header{
                background:#212529;
              
                padding: 10px;
                border-radius:0;
              }
              .modal-content .modal-header .modal-title {
                color: white !important;
                margin-bottom: 0px;
              }
              .modal-header .close {
                color: white !important;
                display:none;
              }
                .white-content .modal-content {
                  background: transparent !important;
                }

                @media (min-width: 576px) {
                  .modal-dialog {
                    margin: 5px auto;
                  }
}
             
          `}
          </style>

          <ModalBody style={{ background: '#212529', padding: '0', display: 'flex', justifyContent: 'center' }}>
            {/* <img src={imagen?.url} alt={`Image ${imagen?.id}`} style={{ width: "auto", height: window.innerWidth < 600 ? 'auto' : window.innerHeight + 50 }} /> */}


            <ReactPlayer
              url={video?.url}
              controls={true}
              width="100%"
              height={window.innerWidth < 600 ? 'auto' : window.innerHeight + 50}
              opts={opts}

              onPlay={() => {
                axios.post(URL + '/public/contar-visita', { id: video[0]?.id })
                for (let item of lista) {
                  if (item.id === video[0]?.id) {
                    item.views++
                  }
                }
              }}
            />


          </ModalBody>
          {/* <div style={{
            margin: '10px',
            padding: '10px',
            background: '#344675',
            position: "relative",
            bottom: window.innerWidth < 600 ? '100px' : '150px',
            zIndex: '1000',
            width: "300px",
            // height: 'auto'
          }}>
            {video ? <>
              <p style={{
                color: 'white',
                marginBottom: '0',
                fontWeight: '600'
              }}>{video?.titulo}</p>
              <p style={{
                color: 'white',
                fontSize: '10px',
                marginBottom: '0',
              }}>{video?.descripcion}</p>
              <p style={{
                color: 'white',
                fontSize: '9px',
                marginBottom: '0',
                fontWeight: '600',
              }}>{video?.autor}</p>
              <p style={{
                color: 'white',
                fontSize: '9px',
                marginBottom: '0',
              }}>{video?.view}</p>
            </> : null}
          </div> */}
          <div
            style={{
              padding: '0',
              display: 'flex',
              justifyContent: 'center',
              position: 'relative',
              bottom:'20px',
              background: "transparent !important",
            }}
          >
            <Button color="info" onClick={() =>
              setOpen(false)
            }>
              cerrar
            </Button>

          </div>

        </Modal>



        <Links />

      </div>
    </div >

  );
}

export default Videos;
